import { render } from "./viewDrafts.vue?vue&type=template&id=c19954f8"
import script from "./viewDrafts.vue?vue&type=script&lang=js"
export * from "./viewDrafts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__